import { getAnalyticsContext } from "@asurion-core/eventualize-react";
import { useContext } from "react";

import type { RootDispatcherType } from "../rootDispatcher";

export function useAnalytics() {
    return useContext(getAnalyticsContext<RootDispatcherType>());
}
